export default "__VITE_ASSET__1937ab72__"